import type { ModeloDefaultProps } from "../../banner-fixo.props"
import ConteudoBanner from "../conteudoBanner/ConteudoBanner"

export default function Modelo07({ data }: Readonly<ModeloDefaultProps>) {

    const banners = data.banners.slice(0, 3)
    const device = data.device

    return (
        <div className="fixed-banners fixed-banners-tipo7 container">
            <div className="item-banner flex center">

                {banners[0] && (
                    <div className="banner-size">
                        <ConteudoBanner data={{
                            banner: banners[0],
                            device
                        }} />
                    </div>
                )}

                <div className="banner-column flex column">
                    {banners.slice(1, 3).map(currentBanner => (
                        <ConteudoBanner key={currentBanner.id} data={{
                            banner: currentBanner,
                            device: data.device
                        }} />
                    ))}
                </div>
            </div>
        </div>
    )
}